import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './Button';
function getSecondsUntilMidnightEST(): number {
  const now = new Date();
  const estString = now.toLocaleString('en-US', {
    timeZone: 'America/New_York'
  });
  const estNow = new Date(estString);
  const midnight = new Date(estNow);
  midnight.setHours(24, 0, 0, 0);
  return Math.max(0, Math.floor((midnight.getTime() - estNow.getTime()) / 1000));
}
export const HeroSection = () => {
  const [timeLeft, setTimeLeft] = useState(getSecondsUntilMidnightEST());
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getSecondsUntilMidnightEST());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <section className="pt-8 pb-10 px-4 md:px-8 bg-brand-cream overflow-hidden" data-id="element-92">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="space-y-4 mb-8" data-id="element-94">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-brand-green leading-tight" data-id="element-95">
            Recupera tu Energía, Desinflámate y Duerme Profundo en 30 Días
          </h1>
          <p className="text-lg md:text-xl text-brand-charcoal/80" data-id="element-96">
            Sin dietas, sin gimnasio, trabajando CON tus hormonas.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative mb-8" data-id="element-97">
          <div className="absolute inset-0 bg-brand-gold/10 rounded-full blur-3xl transform scale-90" data-id="element-98"></div>
          <img src="https://cdn.magicpatterns.com/uploads/iWWXsjXbYSgt1fFMrv2U7u/Imagen_Producto-compressed.jpg" alt="Paz Hormonal +40" fetchPriority="high" decoding="async" className="relative z-10 w-full max-w-md mx-auto drop-shadow-2xl" data-id="element-99" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.4
      }} className="flex items-center gap-2 text-brand-crimson font-semibold text-base md:text-lg mb-6" data-id="element-100">
          <span className="w-3 h-3 rounded-full bg-brand-crimson animate-pulse" data-id="element-101"></span>
          <span data-id="element-102">Oferta expira en:</span>
          <span className="font-bold tracking-wider bg-brand-crimson/10 px-3 py-1 rounded-md" data-id="element-103">
            {formatTime(timeLeft)}
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.5
      }} data-id="element-104">
          <CTAButton onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-105">
            SÍ, QUIERO MI PAZ HORMONAL — ACCESO POR $37
          </CTAButton>
        </motion.div>
      </div>
    </section>;
};